<template>
	<div class="app-navigation">
		<div class="nav-logo"></div>
		<navigation-user-account class="nav-user"/>
		<div class="nav-links-wrapper">
			<div class="nav-links" ref="links" @scroll="onScroll($event)">
				<navigation-dashboard class="nav-link-wrapper dashboard"/>
				<navigation-patients class="nav-link-wrapper watch-list"
					v-check-user:patients="selectedAccount"
					:updateShadow="updateShadow"
					:onDropdownToggleClick="onDropdownToggleClick"/>
				<!--navigation-devices class="nav-link-wrapper watch-list"
					v-check-user:devices="selectedAccount"/-->
				<navigation-alerts class="nav-link-wrapper alerts"/>
				<navigation-support class="nav-link-wrapper alerts"/>
				<navigation-account class="nav-link-wrapper account"
					v-check-user:profile="selectedAccount"
					:updateShadow="updateShadow"
					:onNavLinkClick="onNavLinkClick"/>
				<div class="nav-link-wrapper admin" v-if="isAdmin">
					<router-link class="nav-link" :to="{ name: 'AdminDashboard' }">
						<svgicon name="watch" :fill="false"></svgicon>
						<span>Admin</span>
						<div class="dropdown-toggle" @click.stop.prevent="onDropdownToggleClick($event)">&#9662;</div>
					</router-link>
					<div class="dropdown-content" @transitionend="updateShadow">
						<router-link :to="{ name: 'AdminDeviceList' }">Devices</router-link>
						<router-link :to="{ name: 'AdminSubscriptionList' }">Subscriptions</router-link>
						<router-link :to="{ name: 'AdminServiceList' }">Services</router-link>
						<router-link :to="{ name: 'AdminReadingTypesList' }">Reading Types List</router-link>
						<router-link :to="{ name: 'AdminDiseaseNamesList' }">Disease Names List</router-link>
						<router-link :to="{ name: 'AdminSSNumberTypesList' }">Social Security Number Types List</router-link>
						<router-link :to="{ name: 'AdminMDCategoriesList' }">Medical Document Categories List</router-link>
						<hr>
						<router-link :to="{ name: 'AdminStaticContentUsePolicy' }">Use Policy</router-link>
						<router-link :to="{ name: 'AdminStaticContentPrivacyPolicy' }">Privacy Policy</router-link>
						<router-link :to="{ name: 'AdminStaticContentTerms' }">Terms Of Use</router-link>
						<hr>
						<router-link :to="{ name: 'AdminHelpContent' }">Help Pages</router-link>
					</div>
				</div>
				<div class="nav-link-wrapper logout">
					<router-link class="nav-link" :to="{ name: 'AuthLogout' }">
						<svgicon name="logout" :fill="false"></svgicon>
						<span>{{ $t('base.auth.logout') }}</span>
					</router-link>
				</div>
				<div class="nav-link-wrapper my-idicare">
					<router-link class="nav-link" :to="{ name: 'MyIdicare', params: { user_uid: user.uid } }">
						<svgicon name="my idicare" :fill="false"></svgicon>
						<!-- <span>{{ $t('labels.general.my_idicare') }}</span> -->
						<span>smart care</span>
					</router-link>
				</div>
			</div>
			<div class="nav-shadow" ref="shadow"></div>
		</div>
		<static-content-links class="desktop"/>
		<locale-flag-selector class="desktop"/>
		<div style="clear:both; height: 50px;"></div>
		<float-support/>
	</div>
</template>

<script>
import LocaleFlagSelector from '@/components/i18n/LocaleFlagSelector'
import StaticContentLinks from '@/components/statics/StaticContentLinks'
import NavigationUserAccount from './account/UserAccount'
import NavigationDashboard from './NavigationDashboard'
import NavigationPatients from './NavigationPatients'
import NavigationDevices from './NavigationDevices'
import NavigationAlerts from './NavigationAlerts'
import NavigationSupport from './NavigationSupport'
import FloatSupport from './FloatSupport'
import NavigationAccount from './NavigationAccount'
export default {
	components: {
		LocaleFlagSelector,
		StaticContentLinks,
		NavigationUserAccount,
		NavigationDashboard,
		NavigationPatients,
		NavigationDevices,
		NavigationAlerts,
		NavigationAccount,
		NavigationSupport,
		FloatSupport
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			ticking: false
		}
	},
	computed: {
		user () {
			return this.$store.getters.getUser
		},
		alerts () {
			return this.$store.getters.getAlerts.filter(alert => alert.type === 1 && !alert.reading_time)
		},
		watches () {
			return this.$store.getters.getWatches
		},
		isAdmin () {
			return this.$store.getters.isAdmin
		},
		matchAccount () {
			return this.$route.path.match(/\/user\/account*/)
		},
		matchAdmin () {
			return this.$route.path.match(/\/admin\/*/)
		},
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		}
	},
	methods: {
		getAll () {
			if (this.user) {
				this.$store.dispatch('getPlan', { context: this, user_uid: this.user.uid })
				this.$store.dispatch('getAccounts', { context: this, user_uid: this.user.uid })
				this.$store.dispatch('getPermissions', { context: this, user_uid: this.user.uid })
			}
		},
		onWatchprofileUpdated (payload) {
			this.getAll()
		},
		onScroll (event) {
			// Scroll optimization with window.requestAnimationFrame
			if (!this.ticking) {
				window.requestAnimationFrame(() => {
					this.updateShadow()
					this.ticking = false
				})
				this.ticking = true
			}
		},
		onNavLinkClick (event) {
			this.toggleDropdown(event.currentTarget.parentElement.querySelector('.dropdown-content'))
		},
		onDropdownToggleClick (event) {
			this.toggleDropdown(event.currentTarget.parentElement.parentElement.querySelector('.dropdown-content'))
		},
		toggleDropdown (dropdown) {
			let height = 0
			for (var i = 0; i < dropdown.children.length; i++) {
				var style = getComputedStyle(dropdown.children[i])
				height += (dropdown.children[i].offsetHeight + parseInt(style.marginTop) + parseInt(style.marginBottom))
			}
			if (dropdown.classList.contains('active')) {
				dropdown.classList.remove('active')
				dropdown.style.height = 0
			} else {
				dropdown.classList.add('active')
				dropdown.style.height = `${height}px`
			}
		},
		updateDropdown (dropdown) {
			let height = 0
			for (let i = 0; i < dropdown.children.length; i++) {
				let style = getComputedStyle(dropdown.children[i])
				height += (dropdown.children[i].offsetHeight + parseInt(style.marginTop) + parseInt(style.marginBottom))
			}
			if (dropdown.classList.contains('active')) {
				dropdown.style.height = `${height}px`
			} else {
				dropdown.style.height = 0
			}
		},
		updateShadow () {
			var links = this.$refs.links
			var shadow = this.$refs.shadow
			var diff = links.scrollHeight - links.offsetHeight
			links.scrollTop > 0 ?
				shadow.classList.add('shadow-top') : shadow.classList.remove('shadow-top')
			links.scrollTop < diff ?
				shadow.classList.add('shadow-bottom') : shadow.classList.remove('shadow-bottom')
		},
		matchWatchUser (user_uid, watch_id) {
			return this.$route.path.match(new RegExp(`\/users\/${user_uid}\/watches\/${watch_id}`))
		}
	},
	mounted () {
		this.$root.$on('watch-profile-updated', this.onWatchprofileUpdated)
		this.getAll()
	},
	updated () {
		if (this.$refs.watches) {
			this.updateDropdown(this.$refs.watches)
		}
	},
	beforeDestroy () {
		this.$root.$off('watch-profile-updated', this.onWatchprofileUpdated)
	}
}
</script>

<style scoped>
.app-navigation .nav-logo {
	background-image: url(/static/img/pt/logoe.png) !important;
	width: 215px !important;
	height: 40px !important;
	background-position: center;
	display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navigation/Navigation.vue